
(() => {
  "use strict";
  if (window.SKMAddressDraftInitialized) return;

  const dialog = document.getElementById("skm-address-dialog");
  const dataElement = document.getElementById("skm-address-demo-data");
  if (!dialog || !dataElement) return;
  window.SKMAddressDraftInitialized = true;


  const postalConfig = JSON.parse(dataElement.textContent);
  const endpoint = new URL(postalConfig.endpoint);
  if (endpoint.href !== "https://api.skmaster.com.mx/postal-code") return;
  let pendingController = null;
  let lookupSequence = 0;

  const form = dialog.querySelector("form");
  const field = (name) => form.elements.namedItem(name);
  const cp = field("postal_code");
  const colonia = field("neighborhood");
  const state = field("state");
  const city = field("city");
  const message = dialog.querySelector("[data-skm-message]");
  const summary = dialog.querySelector("[data-skm-summary]");
  const continueButton = dialog.querySelector("[data-skm-continue]");
  if (!continueButton) return;
  let navigatingToCheckout = false;
  let options = [];

  function clearReview() {
    summary.hidden = true;
    summary.textContent = "";
    continueButton.hidden = true;
  }

  function clearLocation() {
    options = [];
    colonia.replaceChildren(new Option("Selecciona una colonia", ""));
    colonia.disabled = true;
    state.value = "";
    city.value = "";
    clearReview();
  }


  cp.addEventListener("input", async () => {
    const sequence = ++lookupSequence;
    if (pendingController) pendingController.abort();
    clearLocation();
    cp.setCustomValidity("");
    message.textContent = "";

    const requestedCp = cp.value;
    if (!/^[0-9]{5}$/.test(requestedCp)) {
      message.textContent = "Introduce los 5 dígitos del código postal.";
      return;
    }

    cp.setCustomValidity("Espera a que termine la consulta del código postal.");
    message.textContent = "Buscando colonias…";
    const controller = new AbortController();
    pendingController = controller;
    let timedOut = false;
    const timeout = setTimeout(() => {
      timedOut = true;
      controller.abort();
    }, 8000);

    try {
      const url = new URL(endpoint.href);
      url.searchParams.set("cp", requestedCp);
      const response = await fetch(url.href, {
        method: "GET",
        headers: {"Accept": "application/json"},
        credentials: "omit",
        cache: "no-store",
        redirect: "error",
        signal: controller.signal
      });

      if (sequence !== lookupSequence || cp.value !== requestedCp) return;
      if (response.status === 404) {
        cp.setCustomValidity("No encontramos este código postal.");
        message.textContent = "Verifica el código postal; no aparece en el catálogo.";
        return;
      }
      if (!response.ok) throw new Error("POSTAL_UNAVAILABLE");
      const data = await response.json();
      if (sequence !== lookupSequence || cp.value !== requestedCp) return;

      const valid = data.success === true && data.cp === requestedCp &&
        Array.isArray(data.options) && data.options.length > 0 &&
        data.options.every((option) =>
          option && option.postal_code === requestedCp &&
          ["state", "city", "neighborhood", "label"].every(
            (name) => typeof option[name] === "string" && option[name].trim()
          )
        );
      if (!valid) throw new Error("INVALID_POSTAL_RESPONSE");

      options = data.options;
      options.forEach((option, index) => {
        colonia.add(new Option(option.neighborhood, String(index)));
      });
      colonia.disabled = false;
      cp.setCustomValidity("");
      message.textContent = "Selecciona tu colonia para completar municipio y estado.";
    } catch {
      if (sequence !== lookupSequence || cp.value !== requestedCp) return;
      clearLocation();
      cp.setCustomValidity("No pudimos consultar el código postal. Intenta nuevamente.");
      message.textContent = timedOut
        ? "La consulta tardó demasiado. Vuelve a introducir el código postal."
        : "No pudimos cargar las colonias. Revisa tu conexión y vuelve a introducir el código postal.";
    } finally {
      clearTimeout(timeout);
      if (pendingController === controller) pendingController = null;
    }
  });

  colonia.addEventListener("change", () => {
    state.value = "";
    city.value = "";
    clearReview();
    const option = colonia.value === "" ? null : options[Number(colonia.value)];
    if (option) {
      state.value = option.state;
      city.value = option.city;
      message.textContent = "Completa los datos de quien recibe y la calle.";
    }
  });

  form.addEventListener("input", clearReview);
  form.addEventListener("submit", (event) => {
    event.preventDefault();

    for (const name of ["first_name", "last_name", "street", "exterior"]) {
      field(name).value = field(name).value.trim();
    }
    if (!form.reportValidity()) return;

    const option = colonia.value === "" ? null : options[Number(colonia.value)];
    if (!option || option.postal_code !== cp.value) {
      message.textContent = "Selecciona una colonia del CP actual.";
      colonia.focus();
      return;
    }

    const get = (name) => field(name).value.trim();
    const address1 = get("street") + " " + get("exterior") +
      (get("interior") ? ", interior " + get("interior") : "");

    summary.textContent = [
      "REVISA TU DIRECCIÓN",
      get("first_name") + " " + get("last_name"),
      "Teléfono: +52 " + get("phone"),
      address1,
      "Colonia: " + option.neighborhood,
      "CP: " + option.postal_code,
      option.city + ", " + option.state,
      "México",
      "",
      "Confirma estos datos antes de continuar."
    ].join("\n");
    summary.hidden = false;
    continueButton.hidden = false;
    message.textContent =
      "Revisa calle y número. Si todo es correcto, pulsa Continuar al pago.";
  });


  // El nodo permanece en memoria si el tema renueva el carrito por AJAX.
  function mountAddress() {
    const mount = document.querySelector("[data-skm-address-mount]");
    if (!mount) {
      dialog.hidden = true;
      return;
    }
    if (dialog.parentElement !== mount) mount.appendChild(dialog);
    dialog.hidden = false;
  }

  function focusAddress() {
    mountAddress();
    if (dialog.hidden) return;
    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    dialog.scrollIntoView({
      behavior: reduced ? "auto" : "smooth",
      block: "start"
    });
    cp.focus({preventScroll: true});
  }

  function isCartCheckout(button) {
    return button && button.matches('[name="checkout"]') && button.form &&
      (button.form.id === "cart" ||
       button.form.matches(".drawer__footer-buttons"));
  }

  function reviewFromCart(button) {
    if (button.form.matches(".drawer__footer-buttons")) {
      // Conserva el carrito existente; dirige al formulario del carrito.
      const target = new URL(dialog.dataset.cartUrl, window.location.origin);
      if (target.origin !== window.location.origin) return;
      target.hash = "skm-address-dialog";
      window.location.assign(target.href);
      return;
    }
    focusAddress();
    form.requestSubmit();
  }

  document.addEventListener("click", (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('button[name="checkout"], input[name="checkout"]')
      : null;
    if (!isCartCheckout(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reviewFromCart(button);
  }, true);

  document.addEventListener("submit", (event) => {
    if (!isCartCheckout(event.submitter)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reviewFromCart(event.submitter);
  }, true);


  continueButton.addEventListener("click", () => {
    if (navigatingToCheckout) return;

    // Vuelve a validar antes de construir la dirección.
    form.requestSubmit();
    if (summary.hidden || continueButton.hidden) return;

    const option = colonia.value === "" ? null : options[Number(colonia.value)];
    if (!option || option.postal_code !== cp.value) return;
    const get = (name) => field(name).value.trim();

    const target = new URL(dialog.dataset.cartUrl, window.location.origin);
    if (target.origin !== window.location.origin) return;

    // Conserva el prefijo de idioma de la ruta del carrito.
    if (!/\/cart\/?$/.test(target.pathname)) {
      message.textContent = "No pudimos preparar el acceso al pago.";
      return;
    }
    target.pathname = target.pathname.replace(/\/cart\/?$/, "/checkout");
    target.search = "";
    target.hash = "";

    const address = {
      first_name: get("first_name"),
      last_name: get("last_name"),
      address1: get("street") + " " + get("exterior") +
        (get("interior") ? ", interior " + get("interior") : ""),
      address2: option.neighborhood,
      city: option.city,
      province: option.state,
      country: "Mexico",
      zip: option.postal_code
    };

    for (const [name, value] of Object.entries(address)) {
      target.searchParams.set("checkout[shipping_address][" + name + "]", value);
    }

    const checkoutPhone = "+52" + get("phone");
    target.searchParams.set("checkout[phone]", checkoutPhone);
    target.searchParams.set("checkout[shipping_address][phone]", checkoutPhone);

    navigatingToCheckout = true;
    continueButton.disabled = true;
    window.location.assign(target.href);
  });

  window.addEventListener("pageshow", () => {
    navigatingToCheckout = false;
    continueButton.disabled = false;
  });

  mountAddress();
  const observer = new MutationObserver(mountAddress);
  observer.observe(document.body, {childList: true, subtree: true});
  if (window.location.hash === "#skm-address-dialog") focusAddress();
})();
